import React from "react";
import { Container } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { JoyrideHits } from "../../components/joyride/whiteLabel/JoyrideHits";
import Wrapper from "../../components/wrapper";

interface IDomainWrapperProps {
  children: React.ReactNode;
}

export default function DomainWrapper({ children }: IDomainWrapperProps) {
  const { t } = useTranslation();

  return (
    <Wrapper mainBlockClassName="white-label-wrapper">
      <Container>
        <h2 className="fw-bold fs-1 mb-4 mb-md-5">{t("menu.Custom Domain")}</h2>
        <div id="subdomain">
          <div className="fw-bold fs-5 mb-3">
            {t("whiteLabel.Project Domain")}
          </div>
          <div className="bg-success-bg text-success p-3 rounded d-flex mb-3 fs-7 align-items-baseline">
            <div>
              <InfoCircle className="pe-2" height={24} width={24} />
            </div>
            {t("whiteLabel.projectDomainDescription")}
          </div>
          {children}
        </div>
      </Container>
      <JoyrideHits />
    </Wrapper>
  );
}
